export const initialState = {
  filters: {},
  translators: []
};
